import { getI18nRoute } from "src/utils/i18nRoutes";
import { ShopType } from "src/utils/genderLocale/genderLocale";
import { Locale } from "src/lib/Intl";

const getAllBrandsPageRoute = ({
  shopType,
  locale,
}: {
  shopType: ShopType;
  locale: Locale;
}): string => {
  return getI18nRoute({
    route: `/${shopType}/brands`,
    locale,
  });
};

export default getAllBrandsPageRoute;
